<template>
  <div class="eventComp_mode_19 eventComp_mode_container" v-show="currThemeObj">
    <div class="tableScrollArea" ref="tableParentDom">
      <multiLevelFold_table
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :tableMode="tableMode"
        :parentWidthPx="parentWidthPx"
        :isScrollFlag="isScrollFlag"
        :variableColWidthVw="variableColWidthVw"
        :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
        :defaultWidthVwNum="defaultWidthVwNum"
        :tableColumnData="tableColumnData"
        :tableData="tableData"
        @toParentEvent="toParentEventHandler"
        v-show="tableData && tableData.length > 0"
      ></multiLevelFold_table>
    </div>
  </div>
</template>

<script>
// 适用： 对称的表格 击剑【T|A】 柔道【T】 网球【A || D】（普通表格）
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_19',
  components: {
    multiLevelFold_table,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    tabType: {
      type: String, //确定数据来自于 出场名单'startList'  || 本场数据'localData',
      default: '',
    },
    competitorType: {
      type: String, //数据的类型 A || D || T,
      default: '',
    },
    indexNo: {
      type: Number,
      default: null, // 1 || 2 ... 从1起
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_19 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isScrollBottom: false,
      tableMode: 'eventComp_mode_19',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: 16.66,
      tableCellDefaultWidthVw: 6.94,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      currModeObj: null,
      renderModeList: [
        {
          // modeName: 'playerInforForColumn1', //从0开始计算
          columnKeyArr: ['VS'],
          columnKeyWidthVwArr: [4.16],
          variableColWidthVwColTitleArr: ['运动员'],
          variableColWidthVw: 16.66,
          tableCellDefaultWidthVw: 6.94,
          sportsIdArr: ['JUD'],
          datasChildKey: 'result_against', //datas下需要的数据字段
        },
        {
          // modeName: 'playerInforForColumn1', //从0开始计算
          columnKeyArr: ['field'],
          columnKeyWidthVwArr: [13.88],
          variableColWidthVwColTitleArr: [],
          variableColWidthVw: 0,
          tableCellDefaultWidthVw: 6.94,
          sportsIdArr: ['TEN'],
          datasChildKey: 'competitorStats', //datas下需要的数据字段
          deleteCustomColumnNum: 1, // 减去这1列[中间列]
        },
        {
          // modeName: 'playerInforForColumn1', //从0开始计算
          columnKeyArr: ['VS'],
          columnKeyWidthVwArr: [4.16],
          variableColWidthVwColTitleArr: [],
          variableColWidthVw: 20.83,
          tableCellDefaultWidthVw: 6.94,
          sportsIdArr: ['FEN'],
          datasChildKey: 'result_against', //datas下需要的数据字段
          deleteCustomColumnNum: 3, // 减去这3列[运动员+中间列+运动员]
          isCompetitorTypeArr: ['T'],
          indexNo: 1,
        },
        {
          // modeName: 'playerInforForColumn1', //从0开始计算
          columnKeyArr: ['category'],
          columnKeyWidthVwArr: [16.66],
          variableColWidthVwColTitleArr: [],
          variableColWidthVw: 0,
          tableCellDefaultWidthVw: 6.94,
          sportsIdArr: ['FEN'],
          datasChildKey: 'result_card', //datas下需要的数据字段
          deleteCustomColumnNum: 1, // 减去这1列[中间列]
          isCompetitorTypeArr: ['A', 'T'],
          indexNo: 2,
        },
      ],
    }
  },
  beforeCreate() {},
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        this.onResizeEvent()
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (modeItem.isCompetitorTypeArr) {
              if (
                modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId) &&
                modeItem.isCompetitorTypeArr.includes(this.competitorType)
              ) {
                if (this.indexNo && modeItem.indexNo) {
                  if (this.indexNo === modeItem.indexNo) {
                    this.currModeObj = modeItem
                  }
                } else {
                  this.currModeObj = modeItem
                }
              }
            } else {
              if (
                modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId)
              ) {
                this.currModeObj = modeItem
              }
            }
          })
        }

        this.computedModeData(
          JSON.parse(JSON.stringify(this.datas[this.currModeObj.datasChildKey]))
        )
      })
    },
    toParentEventHandler(data) {
      console.debug(data)
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedSymmetricData(datas, centerKeyArr, centerColumnItem) {
      // 组装成对称表格数据
      // centerKeyArr：中间一列每一行显示的值
      // centerColumnItem：中间一列表头对应的column元素，结构跟table_head中元素一样
      let data = []
      let table_head = []
      if (
        datas.home &&
        datas.away &&
        datas.table_head &&
        datas.table_head.length > 0
      ) {
        let homePlayerList = datas.home.players
        let awayPlayerList = datas.away.players
        let maxPlayerNum = 0
        let home_table_head =
          datas.table_head.length > 0
            ? datas.table_head.map((column) => {
                let newCol = {
                  name: column.name,
                  desc: column.desc,
                  map_key_arr: [],
                }
                if (column.name === '运动员') {
                  newCol.map_key_arr.push(
                    `homeMode19_playerName-playerLogo-playerGender-teamLogo-teamName`
                  )
                } else if (
                  column.map_key_arr &&
                  column.map_key_arr.length === 1
                ) {
                  newCol.map_key_arr.push(`homeMode19_${column.map_key_arr[0]}`)
                }
                return newCol
              })
            : []
        let away_table_head =
          datas.table_head.length > 0
            ? datas.table_head.reverse().map((column) => {
                let newCol = {
                  name: column.name,
                  desc: column.desc,
                  map_key_arr: [],
                }
                if (column.name === '运动员') {
                  newCol.map_key_arr.push(
                    `awayMode19_playerName-playerLogo-playerGender-teamLogo-teamName`
                  )
                } else if (
                  column.map_key_arr &&
                  column.map_key_arr.length === 1
                ) {
                  newCol.map_key_arr.push(`awayMode19_${column.map_key_arr[0]}`)
                }
                return newCol
              })
            : []
        table_head = [].concat(
          home_table_head,
          centerColumnItem,
          away_table_head
        )
        console.debug(table_head)
        if (homePlayerList.length >= awayPlayerList.length) {
          maxPlayerNum = homePlayerList.length
        } else {
          maxPlayerNum = awayPlayerList.length
        }
        for (let i = 0; i < maxPlayerNum; i++) {
          data.push({
            home: homePlayerList[i],
            away: awayPlayerList[i],
            vs: centerKeyArr.length > 0 ? centerKeyArr[i] : centerKeyArr[0],
          })
        }
      }
      return {
        data,
        table_head,
      }
    },
    computedModeData(data) {
      console.debug('computedModeData:', data)
      if (data && data.data) {
        this.tableTotal = data ? data.length : 0
        const table_headArr = data.table_head

        // 表头
        const headColumns = []
        let variableColWidthVwColTitleArr = []
        table_headArr.forEach((colums) => {
          if (colums && colums.map_key_arr.length > 1) {
            if (colums.name === '运动员') {
              const keyType = colums.map_key_arr[0].split('_')[0]
              headColumns.push({
                colKey: `${keyType}Mode19_playerName-playerLogo-playerGender-teamLogo-teamName`,
                colTitle: colums.name ? colums.name : '',
              })
            }
            if (this.currSportsDetail.sportsId === 'FEN') {
              variableColWidthVwColTitleArr.push(colums.name)
              const keyType = colums.map_key_arr[0].split('_')[0]
              headColumns.push({
                colKey: `${keyType}Mode19_playerName-playerLogo`,
                colTitle: colums.name ? colums.name : '',
              })
            }
          } else {
            headColumns.push({
              colKey: colums.map_key_arr[0] ? colums.map_key_arr[0] : '',
              colTitle: colums.name ? colums.name : '',
            })
          }
        })
        if (this.currSportsDetail.sportsId === 'FEN') {
          this.currModeObj.variableColWidthVwColTitleArr =
            variableColWidthVwColTitleArr
        }
        console.debug(variableColWidthVwColTitleArr)

        const otherColumns = headColumns

        if (this.tableColumnData.length == 0) {
          let tableColumnData = []

          for (let i = 0; i < otherColumns.length; i++) {
            const item = otherColumns[i]
            let widthVw = this.currModeObj.tableCellDefaultWidthVw

            let columnInd = this.currModeObj.columnKeyArr.indexOf(item.colKey)
            console.debug(item.colTitle, columnInd)
            if (columnInd > -1) {
              widthVw = this.currModeObj.columnKeyWidthVwArr[columnInd]
            }
            if (
              this.currModeObj.variableColWidthVwColTitleArr.includes(
                item.colTitle
              )
            ) {
              widthVw = this.currModeObj.variableColWidthVw
            }
            tableColumnData.push({
              prop: item.colKey,
              label: item.colTitle,
              // widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
              //   ? this.tableCellDefaultWidthVw / 2
              //   : this.tableCellDefaultWidthVw, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
              // className: ['arrowIcon', 'isExpand'].includes(item.colKey)
              //   ? 'expandTdClassName'
              //   : '', //单独定制的头部样式class
              widthVw,
              className: '',
              selected: '',
            })
          }

          this.defaultWidthVwNum =
            tableColumnData.length - this.currModeObj.deleteCustomColumnNum
          this.tableColumnData = tableColumnData
        }
        this.tableData = data.data.map((rowData) => {
          return rowData
        })
        // this.$refs.tableParentDom.scrollTo(0, 0)
        console.debug(
          'this.tableData:',
          this.tableData,
          this.tableColumnData,
          this.currSportsDetail.sportsId
        )
      } else {
        console.debug('暂无数据')
        this.notDataHandler()
      }
    },
    notDataHandler() {
      this.tableTotal = 0
      this.tableData = []
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  .tableScrollArea {
    position: relative;
    width: 100%;
  }
}
</style>
